import React from 'react';

import { Row, Col, Switch, Select } from 'antd';

import CustomMaskedInput from 'components/MaskedInput';
import type IProduct from 'interfaces/IProduct';
import { Space } from 'v2/components/Shared/Space';
import { EChargeType, EComissionType } from 'v2/interfaces/product';

export type Props = {
  loading: boolean;
  product: IProduct;
  handleChange: (name: string, value: any) => void;
  validInput: (field: string) => boolean;
  errorFor: (field: string) => string;
  classes: any;
  isSubscription: boolean;
  userHasSubscriptionModule: boolean;
};

export const Recruitment = ({ product, handleChange, validInput, errorFor, isSubscription }: Props) => {
  const changeSwitchState = (name: string) => (checked: boolean) => handleChange(name, checked);
  const changeTextValue = (name: string) => (value: number | string) => handleChange(name, value);

  return (
    <>
      <div className='flex items-center gap-2'>
        <Switch checked={product.recruit} onChange={changeSwitchState('recruit')} />
        <span>Comissão de recrutamento</span>
      </div>
      <p className='mt-1! mb-0! text-xs text-gray-500'>
        Ex: O Afiliado que indicar outro Afiliado receberá parte das primeiras vendas deste afiliado indicado.{' '}
        <a
          target='_blank'
          rel='noopener noreferrer'
          href='https://ajuda.eduzz.com/hc/pt-br/articles/13004454300443-Como-Convidar-um-Afiliado-Atrav%C3%A9s-da-Ferramenta-de-Recrutamento'
        >
          Saiba Mais
        </a>
      </p>

      {product.recruit && (
        <>
          <Space axis='vertical' size={16} />

          <Row justify='space-between' gutter={[32, 16]}>
            <Col xs={24} md={8}>
              <div>
                <label className='mb-1 block text-sm'>Tipo de comissão</label>
                <Select
                  id='recruit_commission_type'
                  className='w-full'
                  value={product.recruit_commission_type}
                  onChange={value => handleChange('recruit_commission_type', value)}
                  disabled={product.recruit_commission_type === EComissionType.PERCENTAGE}
                  options={[
                    { value: EComissionType.PERCENTAGE, label: 'Porcentagem' },
                    ...(product.recruit_commission_type === EComissionType.VALUE &&
                    product.charge_type !== EChargeType.FREE
                      ? [{ value: EComissionType.VALUE, label: 'Valor', disabled: true }]
                      : [])
                  ]}
                />
                <p className='mt-1 text-xs text-gray-500'>Comissão com percentual de ganho bruto.</p>
              </div>
            </Col>

            {product.recruit_commission_type === EComissionType.PERCENTAGE && (
              <Col xs={24} md={8}>
                <CustomMaskedInput
                  fullWidth
                  label='Percentual de comissão recorrente'
                  disableUnderline
                  InputLabelProps={{ shrink: true }}
                  mask='percent'
                  startAdornment='%'
                  value={product.recruit_commission_value}
                  onChange={changeTextValue('recruit_commission_value')}
                  helperText={validInput('recruit_commission_value') ? errorFor('recruit_commission_value') : ''}
                  error={validInput('recruit_commission_value')}
                />
              </Col>
            )}
            {product.recruit_commission_type === EComissionType.VALUE && (
              <Col xs={24} md={8}>
                <CustomMaskedInput
                  fullWidth
                  label='Valor da comissão'
                  disableUnderline
                  InputLabelProps={{ shrink: true }}
                  mask='money'
                  startAdornment='R$'
                  value={product.recruit_commission_value}
                  onChange={changeTextValue('recruit_commission_value')}
                  helperText={validInput('recruit_commission_value') ? errorFor('recruit_commission_value') : ''}
                  error={validInput('recruit_commission_value')}
                />
              </Col>
            )}

            <Col xs={24} md={8}>
              <CustomMaskedInput
                fullWidth
                disableUnderline
                InputLabelProps={{ shrink: true }}
                helperText='Limite de vendas que gerará comissão.'
                label='Máximo de vendas'
                mask='number'
                value={product.recruit_max_sales}
                onChange={changeTextValue('recruit_max_sales')}
              />
            </Col>
          </Row>
        </>
      )}

      {isSubscription && product.membership_fee && product.membership_comission_type === EComissionType.VALUE && (
        <Col xs={24} md={8}>
          <CustomMaskedInput
            fullWidth
            label='Valor da comissão de adesão'
            helperText={validInput('membership_comission_value') ? errorFor('membership_comission_value') : ''}
            error={validInput('membership_comission_value')}
            disableUnderline
            InputLabelProps={{ shrink: true }}
            mask='money'
            startAdornment='R$'
            value={product.membership_comission_value}
            onChange={changeTextValue('membership_comission_value')}
          />
        </Col>
      )}
    </>
  );
};
